<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.esNuevo ? 'Crear' : data.esEliminar ? 'Eliminar': data.esVista
    ? 'Ver' : 'Modificar' }} </strong></h2>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="!data.esVista">
  <form [formGroup]="form">
    <ng-container *ngIf="data.esEliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Descripción</mat-label>
        <input cdkFocusInitial matInput type="text" maxlength="100" style="text-transform: uppercase"
          formControlName="Descripcion" />
       <mat-error *ngIf="f.Descripcion.errors?.required"
            >Este campo es <strong>requerido</strong>.</mat-error
          >
          <mat-error *ngIf="f.Descripcion.errors?.maxlength"
            >Superó el largo máximo.</mat-error
          >
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100" *ngIf="!data.esEliminar; else elseTemplate">
        <mat-label>Observaciones</mat-label>
        <textarea matInput #message name="Observaciones" formControlName="Observaciones"
          ></textarea>
        <mat-hint align="start">Amplie información</mat-hint>
        <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>
        <mat-error *ngIf="form.controls['Observaciones'].hasError('maxlength')">Supero el largo maximo.</mat-error>
      </mat-form-field>
    </ng-template>
  </form>

</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.esVista">

  <div *ngIf="data">
    <div class="property-row">
      <span class="property-name">Descripción:</span>
      <span class="property-value"> {{ data.item?.descripcion}}</span>
    </div>
    <div class="property-row">
      <span class="property-name">Observaciones:</span>
      <span class="property-value"> {{ data.item?.observaciones }}</span>
    </div>
  </div>

</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add  [disabled]="!form.valid" (agregarClicked)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.esEditar"></app-button-save>

  <app-button-delete-and-cancel (deleteClicked)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.esEliminar"
    [isDialogClose]="true"></app-button-delete-and-cancel>


  <app-button-close *ngIf="data.esVista"></app-button-close>
</mat-dialog-actions>
